// extracted by mini-css-extract-plugin
export const container = "footer-module--container--uuQAF";
export const phoneNumbers = "footer-module--phoneNumbers--3BHvh";
export const innerContainer = "footer-module--inner-container--3VYRF";
export const icon = "footer-module--icon--3tulD";
export const footerColumn = "footer-module--footerColumn--Wgo3L";
export const two = "footer-module--two--6omuh";
export const three = "footer-module--three--3eA4Z";
export const copyright = "footer-module--copyright--28ora";